import React from "react";
import { ShieldCheck, Truck, Package, Headphones } from "lucide-react";
const promises = [{
  title: "DIREKTFAHRT",
  description: "Punkt-zu-Punkt Logistik ohne Umladung für maximale Sicherheit.",
  icon: Truck
}, {
  title: "EXPRESS",
  description: "Deutschlandweite Kurierfahrten und Lieferungen bis 3,5 Tonnen.",
  icon: Package
}, {
  title: "BERATUNG",
  description: "Kompetente Planung und Durchführung Ihrer Logistikprojekte.",
  icon: Headphones
}];
export default function TrapgardenQualityPromise() {
  return <section data-section-id="139476" id="erzwerk-standards" className="dark bg-background text-foreground border-t border-white/10 py-16 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3 lg:gap-0 justify-center">
          {promises.map((promise, i) => {
          const Icon = promise.icon;
          return <div key={i} data-index={i} className="group flex flex-col items-center text-center transition-all duration-500 hover:bg-white/[0.02] lg:border-r lg:border-white/10 lg:last:border-r-0 py-8">
                <div className="mb-6 flex h-16 w-16 items-center justify-center bg-primary/5 border border-primary/20 transition-all duration-500 group-hover:scale-105 group-hover:bg-primary group-hover:shadow-[0_0_30px_rgba(0,102,255,0.4)]">
                  <Icon className="h-8 w-8 text-primary transition-colors duration-500 group-hover:text-primary-foreground" strokeWidth={1} />
                </div>
                <h3 className="mb-3 text-[16px] font-serif font-bold uppercase tracking-widest text-foreground">
                  {promise.title}
                </h3>
                <p className="text-[14px] leading-relaxed text-muted-foreground px-4 max-w-[280px]">
                  {promise.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}